import React from "react";
import ContentHowToPlay from "./ContentHowToPlay";
import { ReactComponent as Icon } from "../../../assets/images/icon-how-to-play.svg";
import { activeEventFathom } from "../../../utils/utils";

type MobileProps = {
  lang?: any;
  setOpenModal?: (value: boolean) => void;
  openModal?: boolean;
};
export default function Mobile(props: MobileProps) {
  const { setOpenModal, openModal } = props;
  return (
    <div className="wrapper-how-to-play">
      <div
        className="wrapper-how-to-play-icon"
        onClick={() => {
          setOpenModal(!openModal);
          activeEventFathom("Menu-HowToPlay");
        }}
      >
        <Icon />
      </div>
      <ContentHowToPlay open={openModal} onClose={() => setOpenModal(false)} />
    </div>
  );
}
